module.exports = __webpack_public_path__ + "img/tz.69c7dc03.svg";